import React from "react";
import { Box } from "@mui/material";
import PageHelpButton from "./PageHelpButton";
import { resolvePageHelpKey } from "./resolvePageHelpKey";
import { usePageHelpOverrideValue } from "./PageHelpOverrideContext";
import { PAGE_HELP } from "./pageHelpRegistry";

/**
 * Fixed (i) button — top-right of the viewport below the app bar.
 * Render once in Home.page; does not affect page title layout.
 */
export default function PageHelpCornerHost({ selectedPage, hidden = false }) {
  const override = usePageHelpOverrideValue();
  const pageKey = resolvePageHelpKey(selectedPage);
  const registryEntry = pageKey ? PAGE_HELP[pageKey] : null;

  const hasOverride = Boolean(
    override?.features?.length ||
      override?.title ||
      override?.overview
  );

  if (hidden || !pageKey) return null;
  if (!registryEntry && !hasOverride) return null;

  return (
    <Box
      sx={{
        display: { xs: "none", sm: "block" },
        position: "fixed",
        top: {
          xs: "calc(56px + 8px + env(safe-area-inset-top, 0px))",
          sm: "calc(64px + 12px + env(safe-area-inset-top, 0px))",
        },
        right: { xs: 12, sm: 16 },
        zIndex: (theme) => theme.zIndex.appBar,
        pointerEvents: "none",
      }}
    >
      <Box sx={{ pointerEvents: "auto" }}>
        <PageHelpButton
          pageKey={pageKey}
          features={override?.features}
          title={override?.title}
          overview={override?.overview}
          importantNote={override?.importantNote}
        />
      </Box>
    </Box>
  );
}
